// 字數計算：中文=2，英文=1
export const calculateLength = (str) => {
    if (!str) return 0;
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        // ASCII > 127 視為雙字節字符
        str.charCodeAt(i) > 127 ? len += 2 : len += 1;
    }
    return len;
};

// 時間格式化：轉為用戶本地時間
export const formatTime = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    // 顯示範例：2023/10/27 14:30
    return date.toLocaleString('zh-TW', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit',
        hour12: false 
    });
};